export enum PlatformDocumentKind {
  MAIN_CV = 'main-cv',
  CV = 'cv',
  COVER_LETTER = 'cover-letter',
  CERTIFICATE = 'certificate',
  OTHER = 'other',
}
